export default __webpack_public_path__ + "static/media/govR.ac80640b.png";